import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import * as Sentry from "@sentry/react";
import { CaptureConsole } from "@sentry/integrations";
import { BrowserRouter, Router } from "react-router-dom";

Sentry.init({
  dsn: "https://f8986b58f3b8929c4508a3b3cbc6f598@o4508007566868480.ingest.us.sentry.io/4508007568703488",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    new CaptureConsole({
      levels: ["error"],
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    "https://endeavour.fun",
    "https://hyperapp.in",
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const visibilityChannel = new BroadcastChannel('app-visibility');

document.addEventListener('visibilitychange', () => {
    visibilityChannel.postMessage({ isVisible: document.visibilityState === 'visible' });
});
